// import { useEffect, useState } from 'react';
import axios from 'axios';
import useSWR from 'swr';
import api from './api';

export default function useProductCollection(handle, exclude = [], excludeTags = 'exclude marketplace') {
  // const [products, setProducts] = useState([]);

  const fetcher = async () => {
    const cancelTokenSource = axios.CancelToken.source();


    const isHeaderLiner = window.location.pathname.includes('headliners')

    const endpoint = `${api}/public/experiences?collection=${handle}&isHeadliner=${isHeaderLiner}`;
    // const _products = [];
    // while (next) {
    //   // eslint-disable-next-line no-await-in-loop
    //   const res = await axios.get(
    //     `${next}&filter.v.price.gte=0`,
    //     { cancelToken: cancelTokenSource.token }).then((res) => res.data); // eslint-disable-line
    //   _products.push(...res.products.filter((product) => !!product.data)
    //     .filter((product) => (
    //       !exclude.some((item) => (item.id === product.data.id)
    //       && !product.data.tags.includes(excludeTags))
    //     )));
    //   next = res.next;
    // }

    const res = await axios.get(
      endpoint,
      { cancelToken: cancelTokenSource.token }).then((res) => res.data); // eslint-disable-line

    // const res = await axios.get(`/pages/metafields/${handle}/`);
    // const _products = res.data.products.filter((product) => {
    //   return !exclude.some((item) => {
    //     return item.id === product.data.id;
    //   }) && !product.data.tags.includes(excludeTags);
    // })
    return res
      .filter((product) => (
        !exclude.some((item) => (item.id === product.data.id)
          && !product.tags.includes(excludeTags))
      ));
    // setProducts(data.products);
  };
  const key = `/collections/${handle}`;
  const data = sessionStorage.getItem(key);
  const { data: products = [] } = useSWR(key, fetcher, {
    fallbackData: data && data.length && data[0].title
      ? JSON.parse(sessionStorage.getItem(key)) : [],
    onFailure() {
      window.requestIdleCallback(() => {
        sessionStorage.removeItem(key);
      });
    },
    onSuccess(user) {
      window.requestIdleCallback(() => {
        sessionStorage.setItem(key, JSON.stringify(user));
      });
    },
  });
  // useEffect(() => {
  //   const cancelTokenSource = axios.CancelToken.source();
  //   if (handle) {
  //     (async () => {
  //       let next = `/collections/${handle}?page=1`;
  //       const _products = [];
  //       while (next) {
  //         // eslint-disable-next-line no-await-in-loop
  //         const res = await axios.get(`${next}&filter.v.price.gte=0`,
  //           { cancelToken: cancelTokenSource.token })
  //            .then((res) => res.data); // eslint-disable-line
  //         _products.push(...res.products.filter((product) => !!product.data)
  //           .filter((product) => (
  //             !exclude.some((item) => (item.id === product.data.id)
  //             && !product.data.tags.includes(excludeTags))
  //           )));
  //         next = res.next;
  //       }

  //       // const res = await axios.get(`/pages/metafields/${handle}/`);
  //       // const _products = res.data.products.filter((product) => {
  //       //   return !exclude.some((item) => {
  //       //     return item.id === product.data.id;
  //       //   }) && !product.data.tags.includes(excludeTags);
  //       // })
  //       setProducts(_products);
  //       // setProducts(data.products);
  //     })();
  //   }

  //   return () => {
  //     cancelTokenSource.cancel();
  //   };
  // }, [handle]);
  return products;
}
